import Backbone from "backbone";
import { View } from "../database-reader/base-database-reader";
import { DB_PROVIDERS } from "../database-reader/configs/db-providers";
const module = {};
class CrunchyDataView extends View {
    setup() {
        this.label = "Crunchy Data CDC";
        this.model.get("connectionParams").set("type", DB_PROVIDERS.CRUNCHYDATA.id);
        this.model.set("isCDC", true);
    }
}

module.View = CrunchyDataView;
module.vent = new Backbone.Model();
export default module;
